export default __webpack_public_path__ + "static/media/Aura-Egg__70.685fba57.png";